(function($) {  
	jQuery('.load-form').click(function(){
		var $button = jQuery(this);	
		var form_id = $button.data("fid");
		var url = $button.data("url");

		if ($button.hasClass("loading"))
			return;

		$button.addClass("loading");

		jQuery.get({
			url: valtiolla.ajaxurl,
			data: {
				action: 'gf_button_get_form',
				form_id: form_id,
				url: url
			}
		},function(response){
			jQuery('#gf_button_form_container_'+form_id).html(response).fadeIn();
			if(window['gformInitDatepicker']) {gformInitDatepicker();}
			var _target = $button.parents(".feedback");
		}).success(function(){
			toggleForm();
			$button.removeClass("load-form");
			$button.click(toggleForm);
		} );

		
    });
    
    // Footer form toggle
    function toggleForm(){
        jQuery('.form-wrapper').toggleClass('form-open');
        jQuery('.form-toggle').attr('aria-pressed', function(index, attr){
            return attr == 'false' ? 'true' : 'false';
        });
    }
    
})( jQuery );